import React from 'react';
import { MdDesktopMac, MdCode, MdPhonelinkSetup } from 'react-icons/md';
import styled from 'styled-components';

import SectionTitle from './SectionTitle';
import ServicesSectionItem from './ServicesSectionItem';

const ServicesItemsStyles = styled.div`
  padding: 10rem 0;
  .services__allItems {
    display: flex;
    gap: 10rem;
    justify-content: space-between;
    margin-top: 3rem;
  }
  @media only screen and (max-width: 768px) {
    .services__allItems {
      flex-direction: column;
      max-width: 350px;
      margin: 0 auto;
      margin-top: 2rem;
      gap: 5rem;
    }
  }
`;

export default function ServicesSection() {
  return (
    <ServicesItemsStyles>
      <div className="container">
        <SectionTitle
          subheading="O que eu posso fazer por você"
          heading="Serviços"
        />
        <div className="services__allItems">
          <ServicesSectionItem
            icon={<MdDesktopMac />}
            title="web design"
            desc="UI/UX design garantindo que seu site ou aplicação tenha uma aparência única."
          />
          <ServicesSectionItem
            icon={<MdCode />}
            title="web dev"
            desc="Desenvolvimento de sites e aplicações com foco em alto desempenho e velocidade incrivelmente rápida."
          />
          <ServicesSectionItem
            icon={<MdPhonelinkSetup />}
            title="app Dev"
            desc="Desenvolvimento de aplicativo móvel  com interface do usuário atraente utilizando tecnologias especícas estudadas caso a caso. "
          />
        </div>
      </div>
    </ServicesItemsStyles>
  );
}
